import { render } from "./page4.vue?vue&type=template&id=c437cbd2&scoped=true"
import script from "./page4.vue?vue&type=script&lang=js"
export * from "./page4.vue?vue&type=script&lang=js"

import "./page4.vue?vue&type=style&index=0&id=c437cbd2&scoped=true&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c437cbd2"]])

export default __exports__